"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTransactionToSign = void 0;
const logic_1 = require("./logic");
const api_1 = require("./api");
const constants_1 = require("./constants");
/**
 *
 * @param {ElrondAccount} account
 * @param {SubAccount | null | undefined} tokenAccount
 * @param {Transaction} transaction
 */
const buildTransactionToSign = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const address = account.freshAddress;
    const nonce = yield (0, api_1.getAccountNonce)(address);
    const networkConfig = yield (0, api_1.getNetworkConfig)();
    const chainID = networkConfig.ChainID.valueOf();
    const isTokenAccount = (_a = account.subAccounts) === null || _a === void 0 ? void 0 : _a.some(ta => ta.id === transaction.subAccountId);
    const value = !isTokenAccount && (0, logic_1.isAmountSpentFromBalance)(transaction.mode)
        ? transaction.amount.toFixed()
        : "0";
    const unsigned = Object.assign({ nonce: nonce.valueOf(), value, receiver: transaction.recipient, sender: address, gasPrice: constants_1.GAS_PRICE, gasLimit: transaction.gasLimit || networkConfig.MinGasLimit.valueOf(), data: transaction.data, chainID }, constants_1.HASH_TRANSACTION);
    // Will likely be a call to Elrond SDK
    return JSON.stringify(unsigned);
});
exports.buildTransactionToSign = buildTransactionToSign;
//# sourceMappingURL=js-buildTransaction.js.map